import { Bookmark } from "lucide-react";
import { useBookmarks } from "@/hooks/useBookmarks";
import { useNavigate } from "react-router";

interface BookmarkButtonProps {
  articleId: string;
  variant?: "icon" | "labeled";
}

export function BookmarkButton({
  articleId,
  variant = "icon",
}: BookmarkButtonProps) {
  const { bookmarkedIds, toggle, isSignedIn } = useBookmarks();
  const navigate = useNavigate();
  const isBookmarked = bookmarkedIds.has(articleId);

  const handleClick = async () => {
    if (!isSignedIn) {
      navigate("/signin");
      return;
    }
    await toggle(articleId);
  };

  const label = isBookmarked ? "Saved" : "Save";

  if (variant === "labeled") {
    return (
      <button
        onClick={handleClick}
        aria-label={isBookmarked ? "Remove bookmark" : "Save to bookmarks"}
        className={`inline-flex items-center gap-1.5 h-9 px-3 rounded-md border text-xs font-semibold transition-colors ${
          isBookmarked
            ? "bg-primary text-primary-foreground border-primary"
            : "bg-background text-foreground hover:bg-accent"
        }`}
      >
        <Bookmark
          className={`h-3.5 w-3.5 ${isBookmarked ? "fill-current" : ""}`}
        />
        {label}
      </button>
    );
  }

  return (
    <button
      onClick={handleClick}
      aria-label={isBookmarked ? "Remove bookmark" : "Save to bookmarks"}
      title={isBookmarked ? "Remove bookmark" : "Save to bookmarks"}
      className={`h-9 w-9 inline-flex items-center justify-center rounded-md border transition-colors ${
        isBookmarked
          ? "bg-primary text-primary-foreground border-primary"
          : "bg-background text-foreground hover:bg-accent"
      }`}
    >
      <Bookmark className={`h-4 w-4 ${isBookmarked ? "fill-current" : ""}`} />
    </button>
  );
}
